import { render } from "./Contacts2Import.vue?vue&type=template&id=72c6609a&scoped=true"
import script from "./Contacts2Import.vue?vue&type=script&lang=js"
export * from "./Contacts2Import.vue?vue&type=script&lang=js"

import "./Contacts2Import.vue?vue&type=style&index=0&id=72c6609a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c6609a"]])

export default __exports__